
export const emailTracking = async (ea,el,response,asPath) => {
    
    if (response.customer.id) {
  
      dataLayer.push({
        'event': 'emailSignUp',
        'ecommerce': {
          'ec': 'Subscribe',
          'ea': ea,
          'el': el,
          'fb-el':'CompleteRegistration',
          'signup_customer_id':response.customer.id,
          'tracking_page':asPath
        }
      });	
    }
  
  };

  export const contentViewed = async (productDetails) => {
    dataLayer.push({
      'event':'productDetailsContent',
      'content_name': productDetails?.productDetails?.title,
      'content_category': productDetails?.productDetails?.named_tags?.category,
      'content_ids': productDetails?.productDetails?.id.replace("gid://shopify/Product/", ""),
      'content_type': 'product',
      'value': productDetails?.productDetails?.price,
      'currency': 'USD'
    });
  
  };


export const addToWishlistTrack = async (product) => {
  dataLayer.push({
    'event':'addtowishlist',
    'wishlist_product_id': product?.id?.replace("gid://shopify/Product/", "")
  });	
  
 };

export const navigationTracking = async (label) => {
    dataLayer.push({
      'event': 'clickNavigationMenu',
      'label': label,
    });	
 };

export const PLPFiltersTracking = async (label, value, isRefined) => {
  var trackingFilterLabel = "";
  trackingFilterLabel = isRefined ? "Clear ~ " : "";
  trackingFilterLabel += label === 'Brand' ? 'Designers' : label;
  if(value){
    trackingFilterLabel += " - "+value;
  }
  if(window.location.search?.includes("search_source=oli_plp")){
    trackingFilterLabel = "OLI - " + trackingFilterLabel;
  }
  dataLayer.push({
    'event': 'applyPLPFilter',
    'label': trackingFilterLabel,
    'filterlabel': trackingFilterLabel,
  });	
};
 
//  if user continues their session(login) from the multiple devices we are tracking it inside GA4 by pasing the user "AccessToken"
export const crossDeviceTracking=async ( token )=>{
  dataLayer.push({
    'event': 'login',
    'userId': token
  });	
};
